var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1845 18.186C12.1696 18.186 11.9578 18.3949 11.9578 19.3953V21.2094C11.9578 22.21 12.1696 22.4188 13.1845 22.4188H15.6379V29.6751C15.6379 30.6756 15.8497 30.8844 16.8646 30.8844H19.318C20.3329 30.8844 20.5446 30.6756 20.5446 29.6751V22.4188H23.2994C24.0692 22.4188 24.2676 22.2713 24.479 21.5417L25.0047 19.7276C25.3669 18.4778 25.1437 18.186 23.8252 18.186H20.5446V15.1626C20.5446 14.4947 21.0938 13.9532 21.7713 13.9532H25.2628C26.2776 13.9532 26.4895 13.7444 26.4895 12.7438V10.3251C26.4895 9.32454 26.2776 9.11572 25.2628 9.11572H21.7713C18.3839 9.11572 15.6379 11.823 15.6379 15.1626V18.186H13.1845Z",
    stroke: "#006D33",
    strokeWidth: 1.19577,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.042e5992752ad62a80db9e2d5a1c1ab5.svg";
export { ForwardRef as ReactComponent };